import config from "../../../config/config.json";
import { headers } from "../../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../../../APIHelpers/Responses";

export const studySubjectDiscontinueReasonServices = {
  //Subject Discontinue Reason
  addNewStudySubjectDiscontinueReason,
  updateStudySubjectDiscontinueReasonData,
  deleteStudySubjectDiscontinueReasonData,
  softDeleteRestoreStudySubjectDiscontinueReason,
  getStudySubjectDiscontinueReasonData,
};

// Add New Study Subject Discontinue Reason
async function addNewStudySubjectDiscontinueReason(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewStudySubjectDiscontinueReason`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Update Study Subject Discontinue Reason
async function updateStudySubjectDiscontinueReasonData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateStudySubjectDiscontinueReasonData`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Soft Delete & Restore Study Subject Discontinue Reason
async function softDeleteRestoreStudySubjectDiscontinueReason(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreStudySubjectDiscontinueReason`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Delete Study Subject Discontinue Reason
async function deleteStudySubjectDiscontinueReasonData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteStudySubjectDiscontinueReasonData`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Get Study Subject Discontinue Reason
async function getStudySubjectDiscontinueReasonData(status, studyId, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudySubjectDiscontinueReasonData/${status}/${studyId}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudySubjectDiscontinueReasonData/${status}/${studyId}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}